/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ba-Accordion{width:100%}.ba-Accordion .ba-Accordion-header{width:100%;min-width:0;text-align:left}.ba-Accordion-content>*{width:100%;display:block}\n"}]);